import React from 'react';
import PropTypes from 'prop-types';
import Button from '@components/smartAdminUI/Button';

const AgentActionButtons = ({
  viewClicked,
  auditClicked,
  currRow,
  isEditable,
  isAuditable,
}) => {
  const onViewClick = () => viewClicked(currRow);
  const onAuditClick = () => auditClicked(currRow);

  return (
    <div className="d-flex">
      {isEditable && (
        <Button
          variant="primary iconCenter"
          onClick={onViewClick}
          tooltipText="View Agent"
        >
          <i className="far fa-ellipsis-h" />
        </Button>
      )}
      {isAuditable && (
        <Button
          variant="primary iconCenter"
          onClick={onAuditClick}
          tooltipText="Audit Agent"
        >
          <i className="far fa-history" />
        </Button>
      )}
    </div>
  );
};

AgentActionButtons.propTypes = {
  viewClicked: PropTypes.func.isRequired,
  auditClicked: PropTypes.func.isRequired,
  isAuditable: PropTypes.bool.isRequired,
  isEditable: PropTypes.bool.isRequired,
  currRow: PropTypes.shape({
    UniqueID: PropTypes.number,
  }),
};

export default AgentActionButtons;
